/**
 * Color swatches component that displays matching product variants
 * and allows switching between them with simple a href links
 */

class ColorSwatches {
  constructor() {
    this.container = document.querySelector(".js-color-swatches");
    this.currentProductHandle = window.location.pathname
      .split("/")
      .filter(Boolean)
      .pop();

    this.init();
  }

  async init() {
    if (!this.container) {
      console.error("Color swatches container not found");
      return;
    }

    try {
      // Get the current variant's SKU from the page
      const currentVariantSkuEl = document.querySelector("[data-product-sku]");
      const currentVariantSku = currentVariantSkuEl?.dataset?.productSku;
      if (!currentVariantSku) {
        console.warn("No SKU found for current variant");
        this.container.style.display = "none";
        return;
      }

      // Fetch related products using the SKU
      const products = await this.fetchRelatedProducts(currentVariantSku);

      if (products && products.edges && products.edges.length > 0) {
        this.renderSwatches(products.edges);
      } else {
        this.container.style.display = "none";
      }
    } catch (error) {
      console.error("Error loading products:", error);
      this.container.style.display = "none";
    }
  }

  async fetchRelatedProducts(sku) {
    try {
      const base = `${window.Shopify?.routes?.root || ""}apps/marvya-variants`;
      const response = await fetch(`${base}/${sku}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching related products:", error);
      return null;
    }
  }

  renderSwatches(products) {
    // Find the active product's color label
    const activeProduct = products.find(
      ({ node }) => node.handle === this.currentProductHandle
    );

    const activeColorLabel =
      activeProduct?.node?.metafield?.references?.edges[0]?.node?.fields.find(
        (field) => field.key === "label"
      )?.value || "";

    // Create the swatches HTML
    let html = `
      <div class="color-swatches">
        <div class="color-swatches__title-container">
          <div class="color-swatches__title">Color</div>
          <div class="color-swatches__subtitle">${activeColorLabel}</div>
        </div>
        <div class="color-swatches__items">
    `;

    // Add a swatch for each product
    products.forEach(({ node: product }) => {
      const isActive = product.handle === this.currentProductHandle;
      const activeClass = isActive ? "is-active" : "";

      const colorData =
        product.metafield?.references?.edges[0]?.node?.fields || [];
      const colorLabel =
        colorData.find((field) => field.key === "label")?.value ||
        product.title;
      const colorHex =
        colorData.find((field) => field.key === "color")?.value || "#FFFFFF";

      html += `
        <a href="/products/${product.handle}" 
           class="color-swatch ${activeClass}" 
           title="${colorLabel}"
           aria-label="${colorLabel}"
           data-product-handle="${product.handle}"
           style="background-color: ${colorHex}">
        </a>
      `;
    });

    html += `
        </div>
      </div>
    `;

    this.container.innerHTML = html;
    this.addStyles();
  }

  addStyles() {
    // Only add styles if they don't already exist
    if (document.getElementById("color-swatches-styles")) return;

    const styles = document.createElement("style");
    styles.id = "color-swatches-styles";

    styles.textContent = `
      .color-swatches__subtitle {
        flex-basis: 100%;
        display: block;
        padding-top: 4px;
        font-size: var(--font-body-x-small);
        font-weight: var(--FONT-WEIGHT-BODY-BOLD);
      }
    `;

    document.head.appendChild(styles);
  }
}

// Initialize the component when the DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new ColorSwatches();
});
